import axios from "axios";

function injectLocale({ app, route }) {
    // Extract the requested locale from the URL
    const urlParts = route.fullPath.split('/');
    const requestedLocale = urlParts[1]; // Get the first index after splitting
    // Check if the requested locale is valid
    const isValidLocale = app.i18n.locales.some(locale => locale.code === requestedLocale);
    if (isValidLocale) {
      // Switch to the requested locale
      app.i18n.locale = requestedLocale;
      // Check if the URL ends with a slash but not with a query parameter
      if (urlParts.length <= 2 && !route.fullPath.includes('?')) {
        return (`${route.fullPath}`);
      }
      return;
    }
    // Redirect to the route with the locale path added
    const currentLocale = app.i18n.localeProperties.code || 'fi-fi';
    const redirectTo = `/${currentLocale}${route.fullPath}`;
    return (redirectTo);
}

export async function locationRedirectFunction({ req, app: { $cookies, i18n }, url, route }) {
  if (process.env.BASIC_ENABLED == 'true') return;

  if($cookies.get("userCurLocation")) {
    return injectLocale({ app: { i18n }, route });
  }
  
  // Check if the user has already been redirected
  const isUserRedirected = $cookies.get("301redirected");
  if (isUserRedirected) return;
  
  // Retrieve the user's IP address
  const uIP =
    req.headers["x-forwarded-for"]?.split(",")[0] ||
    req?.connection?.remoteAddress ||
    req?.socket?.remoteAddress ||
    req?.connection?.socket?.remoteAddress;

 let data;

  try {
    // Make an API request to get the user's location
    const response = await axios.get(`${process.env.PRODUCTION_URL}/getCurLocation/${uIP}`, {
      // Include credentials (session cookies) in the request
      withCredentials: true
    });
    data = response.data;
    // Store the geolocation in the cookie
    storeGeolocationInCookie(data);
  } catch (error) {
    console.error("Error retrieving geolocation:", error);
    let addLocaleUrl = injectLocale({ app: { i18n }, route });
    return addLocaleUrl;
  }

  try {
    // Check if the first segment of the URL is a supported locale
    const urlParts = url.split('/');
    const locales = ['fi-fi', 'sv-se', 'no-no', 'en-gb', 'int', 'en-us']; // List of supported locales
    const filteredLocales = locales.filter(country => {
      return process.env.CURRENT_ENV !== 'prod' || country !== '';
    });

    // Check if there is a locale requested in the URL and if it's supported
    if (filteredLocales.includes(urlParts[1])) {
      console.log("Requested locale::", urlParts[1], "Geolocation based locale::", data.locationLocale);
      i18n.setLocale(urlParts[1]);
      return; // Bypass redirection if locale is already present
    }

    // Redirect to the appropriate locale URL
    console.log("geo location redirecting to...", `${process.env.PRODUCTION_URL}/${data.locationLocale}/`);
    console.log(`${process.env.PRODUCTION_URL}/${data.locationLocale}/`);
    return(`${process.env.PRODUCTION_URL}/${data.locationLocale}/`);
  } catch (error) {
    console.error("Error initiating redirection:", error);
    let addLocaleUrl = injectLocale({ app: { i18n }, route });
    return addLocaleUrl;
  }

  function storeGeolocationInCookie(geoLocationInfo) {
    $cookies.set("userCurLocation", geoLocationInfo.geoCCode, {
      maxAge: 60 * 60 * 24 * 15, // Example expiration time
      path: "/", // Cookie path
    });

    // Check if microsite, store location info to use in API requests
    if (geoLocationInfo.mcrCCode){
      $cookies.set("mcrCCode", geoLocationInfo.mcrCCode, {
        maxAge: 60 * 60 * 24 * 15, // Example expiration time
        path: "/", // Cookie path
      });
      
      $cookies.set("mcrCntry", geoLocationInfo.mcrCntry, {
        maxAge: 60 * 60 * 24 * 15, // Example expiration time
        path: "/", // Cookie path
      });
    } else {
      $cookies.remove('mcrCCode');
      $cookies.remove('mcrCntry');
    }
  }
}